const data = {
  pageName: "Basket",
  services: {
    translations: {
      url: "basket/translations",
      params: {}
    },
    data: {
      url: "basket/data",
      params: {}
    },
    basketRemove: {
      url: "basket/basketRemove",
      params: {}
    },
    basketEmpty: {
      url: "basket/basketEmpty",
      params: {}
    },
    basketChangeQuantity: {
      url: "basket/basketChangeQuantity",
      params: {}
    },
    basketChangeEsimQuantity: {
      url: "basket/basketChangeEsimQuantity",
      params: {}
    },
    basketModify: {
      url: "basket/basketModify",
      params: {}
    },
    basketAddPlan: {
      url: "basket/basketAddPlan",
      params: {}
    },
    basketAddTvPlan: {
      url: "basket/basketAddTvPlan",
      params: {}
    },
    validateVoucher: {
      url: "basket/validateVoucher",
      params: {}
    },
    productCharacteristics: {
      url: "basket/productCharacteristics",
      params: {}
    },
    showDeviceInstallments: {
      url: "basket/showDeviceInstallments",
      params: {}
    },
    checkoutOnboardingEligible: {
      url: "basket/checkoutOnboardingEligible",
      params: {}
    }
  }
};

exports.data = data;
